import { isAuthenticatedGuard, hasPermissionGuard } from '@/modules/auth/router/authGuard';
import appConfig from '@/app.config';

import SystemLayout from '@/modules/system/layouts/SystemLayout.vue';
import UsuariosAdminView from '@/modules/administracion/views/UsuariosAdminView.vue';
import RolesAdminView from '@/modules/administracion/views/RolesAdminView.vue';
import SucursalesAdminView from '@/modules/administracion/views/SucursalesAdminView.vue';

export default {
    name: 'administracion',
    component: SystemLayout,
    children: [
        {
            path: '/usuarios-admin',
            name: 'usuarios-admin',
            component: UsuariosAdminView,
            beforeEnter: [isAuthenticatedGuard, hasPermissionGuard('administracion')],
            meta: {
                title: appConfig.TITULO_SISTEMA + ' - Usuarios',
                titleForm: 'Usuarios'
            },
        },
        {
            path: '/roles-admin',
            name: 'roles-admin',
            component: RolesAdminView,
            beforeEnter: [isAuthenticatedGuard, hasPermissionGuard('administracion')],
            meta: {
                title: appConfig.TITULO_SISTEMA + ' - Roles',
                titleForm: 'Roles'
            },
        },
        {
            path: '/sucursales-admin',
            name: 'sucursales-admin',
            component: SucursalesAdminView,
            beforeEnter: [isAuthenticatedGuard, hasPermissionGuard('administracion')],
            meta: {
                title: appConfig.TITULO_SISTEMA + ' - Sucursales',
                titleForm: 'Sucursales'
            },
        },
    ],
};
